import { render, staticRenderFns } from "./CompanyCoordinates_Delete.vue?vue&type=template&id=d4f5cf3a&scoped=true&"
import script from "./CompanyCoordinates_Delete.vue?vue&type=script&lang=js&"
export * from "./CompanyCoordinates_Delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f5cf3a",
  null
  
)

export default component.exports